"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarExcessWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var ExcessExplainedRenderers_1 = require("../../../components/modals/renderers/ExcessExplainedRenderers");
var CommonRenderers_1 = require("../../../helpers/CommonRenderers");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var RemoveCarButton_1 = require("../../../components/subscription/motor/carExcess/RemoveCarButton");
var CarExcessChangePopupWidget_1 = require("../../../components/subscription/motor/carExcess/CarExcessChangePopupWidget");
var services_1 = require("@falcon/services");
var CarExcessWidget = exports.CarExcessWidget = /** @class */ (function (_super) {
    __extends(CarExcessWidget, _super);
    function CarExcessWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToEditCar = function (vehicleIndex) {
            _this.props.engine.navigate("editVehicle".concat(vehicleIndex, "RegistrationNumberPage"), false);
        };
        _this.state = {
            showPopup: false,
            popupShownForVehicles: []
        };
        _this.togglePopUp = _this.togglePopUp.bind(_this);
        _this.handleVoluntaryExcessChange = _this.handleVoluntaryExcessChange.bind(_this);
        _this.removeVehicle = _this.removeVehicle.bind(_this);
        return _this;
    }
    CarExcessWidget.prototype.render = function () {
        return (React.createElement("div", { className: this.getSetting("cssClass", "") },
            this.renderCarPanels(),
            React.createElement(CarExcessChangePopupWidget_1.CarExcessChangePopupWidget, { isOpen: this.state.showPopup, toggle: this.togglePopUp })));
    };
    CarExcessWidget.prototype.renderCarPanels = function () {
        var _this = this;
        var carPanels = [];
        var interaction = this.props.engine.getInteraction();
        interaction.vehicles.forEach(function (vehicle, index) {
            carPanels.push(React.createElement("div", { className: "panel", key: index },
                React.createElement("img", { className: "vehicle-icon mb-3", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png"), alt: "Vehicle icon", "aria-label": "Vehicle icon" }),
                React.createElement("h2", { className: "inner-content text-center font-family-display font-weight-medium mt-0 mb-2" }, "".concat(vehicle.make, ", ").concat(vehicle.model)),
                React.createElement("div", { className: "number-plate-preview mb-3" }, vehicle.registrationNumber),
                React.createElement("div", { className: "mb-3" },
                    React.createElement("p", { className: "text-center m-0" },
                        React.createElement("a", { className: "text-blue-1 text-decoration-underline", onClick: function () { return _this.navigateToEditCar(index); } }, "Edit car details"),
                        interaction.vehicles.length > 1 && (React.createElement(React.Fragment, null,
                            " / ",
                            React.createElement(RemoveCarButton_1.RemoveCarButton, { interaction: interaction, vehicleIndex: index, onRemove: _this.removeVehicle }))))),
                React.createElement("div", { className: "mb-3" },
                    React.createElement("p", { className: "h3 text-center font-weight-bold text-blue-1 m-0" }, "\u00A3".concat(vehicle.ratingOutput.grossPremium)),
                    React.createElement("p", { className: "text-center m-0" }, "For the first month")),
                React.createElement("div", { className: "mb-3" },
                    React.createElement("label", { className: "text-center pl-5 m-0" },
                        "Compulsory excess ",
                        React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Compulsory excess explained" }, (0, ExcessExplainedRenderers_1.renderCompulsoryExcessExplained)(vehicle.excesses))),
                    (0, CommonRenderers_1.renderDriverCompulsoryExcess)(interaction, vehicle)),
                React.createElement("div", { className: "mb-3" },
                    React.createElement("label", { className: "text-center pl-5 mb-3" },
                        "Voluntary excess ",
                        React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Voluntary excess explained" }, (0, ExcessExplainedRenderers_1.renderVoluntaryExcessExplained)(vehicle.excesses))),
                    _this.renderVoluntaryExcessBtns(vehicle))));
        });
        return carPanels;
    };
    CarExcessWidget.prototype.togglePopUp = function () {
        this.setState(function (state) { return ({
            showPopup: !state.showPopup
        }); });
    };
    CarExcessWidget.prototype.renderVoluntaryExcessBtns = function (vehicle) {
        var _this = this;
        var excessAmounts = [0, 100, 200, 300, 400, 500];
        var btns = [];
        excessAmounts.forEach(function (amount, index) {
            var isChecked = amount === vehicle.excesses.voluntaryExcess;
            btns.push((React.createElement("div", { key: index, className: "col-4 mb-3" },
                React.createElement("div", { className: "btn-radio mx-2" },
                    React.createElement("input", { id: "excess".concat(vehicle.registrationNumber, "amount").concat(amount), name: "excess".concat(vehicle.registrationNumber), type: "radio", value: amount, "data-vehicle-index": vehicle.info.index, onChange: _this.handleVoluntaryExcessChange, checked: isChecked }),
                    React.createElement("label", { id: "excess-label-".concat(vehicle.registrationNumber, "-amount-").concat(amount), htmlFor: "excess".concat(vehicle.registrationNumber, "amount").concat(amount) }, "\u00A3".concat(amount))))));
        });
        return (React.createElement("div", { className: "voluntary-excess-btns row no-gutters mx-auto" }, btns));
    };
    CarExcessWidget.prototype.handleVoluntaryExcessChange = function (event) {
        var amount = parseInt(event.target.value);
        var vehicleIndex = event.target.dataset.vehicleIndex;
        this.props.onStateChange("vehicles[".concat(vehicleIndex, "].excesses.voluntaryExcess"), amount);
        this.executeEvent("change");
        var interaction = this.props.engine.getInteraction();
        this.changelogRecorder.record(interaction, "change", "vehicles[".concat(vehicleIndex, "].excesses.voluntaryExcess"), this.props.page && this.props.page.pageId);
        var vehicleExcessChangeIndexes = interaction.uistate.vehicleExcessChangeIndexes.split(",");
        if (amount > 100 && vehicleExcessChangeIndexes.includes(vehicleIndex) && !this.state.popupShownForVehicles.includes(vehicleIndex)) {
            this.setState(function (state) { return ({
                showPopup: true,
                popupShownForVehicles: __spreadArray(__spreadArray([], state.popupShownForVehicles, true), [vehicleIndex], false)
            }); });
        }
    };
    CarExcessWidget.prototype.removeVehicle = function (vehicleIndex) {
        this.props.interaction.vehicles.splice(vehicleIndex, 1);
        this.props.interaction.numberOfVehicles = this.props.interaction.numberOfVehicles - 1;
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", "numberOfVehicles", this.props.page && this.props.page.pageId);
        this.executeEvent("change");
    };
    ;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], CarExcessWidget.prototype, "changelogRecorder", void 0);
    return CarExcessWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=CarExcessWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/CarExcessWidget.js
// module id = 2586
// module chunks = 0